import { Injectable } from '@angular/core';
import { StorageRentFilters } from '@app/infrastructure/api/models';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import {
  SetRentInvoicingListFilters,
  SetRentInvoicingPagination,
  SetRentInvoicingSearchText,
} from './_actions';

export const CURRENT_RENT_INVOICING_LIST_VERSION = 2;

export type RentInvoicingTab = 'all' | 'invoiced' | 'needs-review' | 'ignored';

interface RentInvoicingStateModel {
  version: number;
  tabPagination: Partial<Record<RentInvoicingTab, number>>;
  toDate?: string;
  filters?: StorageRentFilters;
  searchText?: string;
}

export const RENT_INVOICING_STATE_DEFAULTS: RentInvoicingStateModel = {
  version: CURRENT_RENT_INVOICING_LIST_VERSION,
  tabPagination: {},
};

@State<RentInvoicingStateModel>({
  name: 'RentInvoicingList',
  defaults: RENT_INVOICING_STATE_DEFAULTS,
})
@Injectable()
export class RentInvoicingListState {
  @Selector()
  static tabPagination(state: RentInvoicingStateModel): Partial<Record<RentInvoicingTab, number>> {
    return state.tabPagination;
  }

  @Selector()
  static toDate(state: RentInvoicingStateModel): string | undefined {
    return state.toDate;
  }

  @Selector()
  static filters(state: RentInvoicingStateModel): StorageRentFilters | undefined {
    return state.filters;
  }

  @Selector()
  static searchText(state: RentInvoicingStateModel): string | undefined {
    return state.searchText;
  }

  @Action(SetRentInvoicingPagination)
  setPagination(ctx: StateContext<RentInvoicingStateModel>, action: SetRentInvoicingPagination) {
    ctx.patchState({
      tabPagination: { ...ctx.getState().tabPagination, [action.tab]: action.itemsPerPage },
    });
  }

  @Action(SetRentInvoicingSearchText)
  setSearchText(ctx: StateContext<RentInvoicingStateModel>, action: SetRentInvoicingSearchText) {
    ctx.patchState({
      searchText: action.searchText,
    });
  }

  @Action(SetRentInvoicingListFilters)
  setListFilters(ctx: StateContext<RentInvoicingStateModel>, action: SetRentInvoicingListFilters) {
    ctx.patchState({
      toDate: action.toDate,
      filters: action.filters,
    });
  }
}
